export default {
  id: 'a4183a78bc',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page style="background-color: #fff;"><div class="page-content login-screen-content"><div class=login-screen-title><img src=./static/images/jacknb_logo.png style="max-width: 40%;"></div><form><div class=list><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label"><b>Email</b></div><div class=item-input-wrap><input id=signin-email type=text name=username placeholder="Email di registrazione"></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label"><b>Password</b></div><div class=item-input-wrap><input id=signin-password type=password name=password placeholder=Password></div></div></li><!--\r\n\r\n            <li class="item-content">\r\n\r\n              <div class="item-inner">\r\n\r\n                  <div class="g-recaptcha" data-sitekey="6Lc0zyQaAAAAABkJ49kcmVOHYcThWogrPwYTPzql"></div>\r\n\r\n              </div>\r\n\r\n            </li>\r\n            \r\n            --></ul></div><div class=block><p class=row><a id=login href=# class="button button-outline">Accedi</a> <a id=signup href=/signup/ class="button button-outline">Registrati</a></p></div></form><div class=list><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label"><a id=request-reset-password href=# style="font-weight: bold;">Password dimenticata? Clicca qui per reimpostarla!</a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label"><a href=https://jacknb.com/privacy-policy/ style="font-weight: bold;" class="link external">Privacy policy</a></div></div></li></ul></div><div class=web-footer-link2><a href="https://play.google.com/store/apps/details?id=com.jackbcustomer&hl=it"><img height=90% src=./static/images/androidmarketIcona.png onclick=\'location.assign("https://play.google.com/store/apps/details?id=com.jackbcustomer&hl=it")\'></a><a href=https://apps.apple.com/app/id1591974126><img height=90% src=./static/images/appleStoreIcona.png onclick=\'location.assign("https://apps.apple.com/app/id1591974126")\'></a></div></div></div>';
      return r;
    }(this);
  },

  style: `




`,
  styleScoped: false
};